import React, { type FC, useId } from 'react';
import styles from './styles.module.css';

interface CounterProps {
    className?: string;
    disabled?: boolean;
    max?: number;
    min?: number;
    onChange: (value: number) => void;
    value: number;
}

export const Counter: FC<CounterProps> = ({
    className,
    disabled,
    max = Number.POSITIVE_INFINITY,
    min = Number.NEGATIVE_INFINITY,
    onChange,
    value,
}) => {
    const setValue = (rawValue: string | number) => {
        if (disabled) return;

        let value = typeof rawValue === 'string' ? Number.parseInt(rawValue, 10) : rawValue;
        if (Number.isNaN(value)) return;

        value = value < min ? Math.max(value, min) : Math.min(value, max);
        onChange?.(value);
    };

    const decrement = () => value > min && setValue(value - 1);

    const increment = () => value < max && setValue(value + 1);

    return (
        <div className={`flex flex-row items-center p-[1px] bg-gray-100 rounded-md ${disabled ? 'opacity-50' : ''}`}>
            <button
                type="button"
                className="bg-gray-150 w-7 text-xl text-white px-2 rounded-tl-md rounded-bl-md"
                onClick={decrement}
            >
                -
            </button>
            <input
                type="number"
                value={value}
                onChange={(e) => setValue(e.target.value)}
                className={`border-none outline-none bg-gray-100 w-10 py-1 px-1 text-white text-center text-sm ${className} ${styles.counter}`}
            />
            <button
                type="button"
                className="bg-gray-150 w-7 text-xl text-white px-2 rounded-tr-md rounded-br-md"
                onClick={increment}
            >
                +
            </button>
        </div>
    );
};
